import React from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs } from 'js/components/design-system';
import { lawyerBreadcrumbsHistory } from './functions';

const LawyerBreadcrumbs = () => {
  const location = useLocation();
  const { t } = useTranslation();
  return (
    <Breadcrumbs
      className="lawyer-breadcrumbs"
      history={lawyerBreadcrumbsHistory(t, location)}
    />
  );
};

export default LawyerBreadcrumbs;
